var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "7.272 88.46 255.294 63.842",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.084 88.46L7.272 152.22h34.492l4.276-10.166h9.774l4.276 10.166h37.966v-7.759l3.383 7.759h19.639l3.383-7.923v7.923h78.959l9.601-9.902 8.99 9.902 40.555.082-28.903-31.784 28.903-32.058H222.64l-9.346 9.719-8.707-9.719H118.69l-7.376 16.457-7.549-16.457h-34.42v7.495l-3.829-7.495H36.084zm6.674 9.054h16.813l19.111 43.236V97.514H97.1l14.761 31 13.604-31h18.326v45.752H132.64l-.091-35.851-16.257 35.851h-9.975l-16.348-35.851v35.851h-22.94l-4.349-10.257H39.184l-4.34 10.248H22.553l20.205-45.743zm111.235 0h45.342l13.868 14.98 14.315-14.98h13.868l-21.071 22.995 21.071 22.73h-14.497l-13.868-15.154-14.388 15.154h-44.64V97.514zm-103.056 7.741l-7.741 18.272h15.473l-7.732-18.272zm114.253 1.732v8.352h24.736v9.309H165.19v9.118h27.745l12.892-13.43-12.345-13.357H165.19v.008z",
    fill: "currentcolor"
  })));
}

var MemoSvgAmericanExpress = /*#__PURE__*/React.memo(SvgAmericanExpress);
export default MemoSvgAmericanExpress;